module.exports = __webpack_public_path__ + "static/media/icon_configure.3c09906c.svg";